import styled, { css } from 'styled-components';
import { Media } from 'enums';

export const LocationStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};

  @media ${Media.notebook} {
    align-items: flex-start;
  }
`;

export const CustomLayoutStyleForLocationPage = css`
  padding: 60px 0 120px 0;

  @media ${Media.tablet} {
    padding: 60px 0 120px 0;
  }

  @media ${Media.notebook} {
    padding: 80px 0 160px 0;
  }

  @media ${Media.desktop} {
    padding: 120px 0 240px 0;
  }
`;
